import React from 'react';

const Success = () => {
    return (
        <div className='bg-white'>
           <h1 className='flex justify-center items-center text-4xl font-montserrat font-semibold text-green-900'>Payment  Success</h1>
        </div>
    );
};

export default Success;